const impersonateRoute = "/impersonate";

export default impersonateRoute;
